module.exports = __webpack_public_path__ + "static/media/google-logo.1c817d15.svg";